import { create } from '@stylexjs/stylex';
import { colors } from '../theme/colors.stylex';
import { controlMetrics } from '../theme/controls.stylex';

export const styles = create({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    columnGap: '0.75rem',
    rowGap: '0.5rem',
    color: colors.text,
    justifyContent: 'flex-end',
  },
  compact: { flex: 1, justifyContent: 'space-between' },
  controls: { display: 'flex', flexWrap: 'nowrap', alignItems: 'center' },
  nowrap: { whiteSpace: 'nowrap' },
  nav: { display: 'flex' },
  list: { display: 'flex', listStyleType: 'none', margin: 0, padding: 0, alignItems: 'center' },
  button: {
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    position: 'relative',
    marginLeft: '-1px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: controlMetrics.borderWidth,
    borderStyle: 'solid',
    borderColor: colors.border,
    backgroundColor: colors.background,
    color: {
      'default': colors.text,
      ':hover': colors.borderHover,
      ':focus': colors.borderFocus,
      ':active': colors.borderActive,
    },
    textDecorationLine: 'none',
    cursor: 'pointer',
  },
  disabled: {
    cursor: 'not-allowed',
    opacity: 0.5,
    pointerEvents: 'none',
    color: { 'default': colors.text, ':hover': colors.text, ':focus': colors.text, ':active': colors.text },
  },
  active: {
    zIndex: 10,
    borderColor: colors.paginationSelected,
    backgroundColor: colors.paginationSelected,
    color: { 'default': colors.white, ':hover': colors.white, ':focus': colors.white, ':active': colors.white },
  },
  previous: { borderTopLeftRadius: '0.5rem', borderBottomLeftRadius: '0.5rem' },
  next: { borderTopRightRadius: '0.5rem', borderBottomRightRadius: '0.5rem' },
  break: {
    display: 'inline-flex',
    minHeight: '2rem',
    minWidth: '2rem',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    color: colors.text,
  },
  goToSmall: { marginLeft: '5px' },
  wrapperNormal: { marginBlock: '0.375rem' },
  labelNormal: { marginLeft: '10px' },
});
export const buttonSizes = create({
  small: { minWidth: '1.5rem', minHeight: '1.5rem' },
  normal: { minWidth: '2rem', minHeight: controlMetrics.height },
});
export const paddingSizes = create({
  small: { paddingInline: '6px', paddingBlock: '1px' },
  normal: { paddingInline: '15px', paddingBlock: '6px' },
});
export const selectSizes = create({ small: { width: '55px' }, normal: { width: '65px' } });
export const spacingSizes = create({ small: { gap: '0.25rem' }, normal: { gap: '0.375rem' } });
